import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutePathConstants, PageTitleConstants } from "../../../Constants";
import {
  PageHeader,
  Loading,
  toastSuccessMessage,
  useSessionStorageState,
} from "wup-module1-base";
import { Card } from "react-bootstrap";
import QuestionForm from "./Form/QuestionForm";
import { v4 as uuidv4 } from "uuid";

/**
 * Strona dodawania pytania
 * @returns Komponent strony dodawania pytania
 */
function QuestionAdd() {
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [model, setModel] = useState({});
  const [questions, setQuestions] = useSessionStorageState(
    "questions",
    [],
    true
  );

  const navigate = useNavigate();

  const onSubmit = (model) => {
    setIsSubmitting(true);
    //DO IMPLEMENTACJI
    // QuestionService.create(model)
    //   .then((res) => {
    //     toastSuccessMessage(res.data);
    //     navigate(`/${RoutePathConstants.Question}`);
    //   })
    //   .catch((error) => {
    //     toast.error(error.response.data.detail);
    //   })
    //   .finally(() => {
    //     setIsSubmitting(false);
    //   });
    // const questions = JSON.parse(sessionStorage.getItem("questions"));
    // if (!!questions)
    //   sessionStorage.setItem(
    //     "questions",
    //     JSON.stringify([
    //       ...questions,
    //       { ...model, order: questions.length + 1, id: uuidv4() },
    //     ])
    //   );
    // else
    //   sessionStorage.setItem(
    //     "questions",
    //     JSON.stringify([{ ...model, order: 1, id: uuidv4() }])
    //   );

    const question = {
      ...model,
      order: questions.length + 1,
      id: uuidv4(),
    };
    const tempQuestions = [...questions];
    tempQuestions.push(question);
    setQuestions(tempQuestions);

    setIsSubmitting(false);
    toastSuccessMessage(`Pomyślnie dodano pytanie ${model.name}`);
    navigate(`/${RoutePathConstants.Question}`);
  };

  useEffect(() => {
    setIsLoading(true);
    const question = {
      relatedQuestions: [],
    };
    setModel(question);
    setIsLoading(false);
  }, []);

  return (
    <>
      <PageHeader content={PageTitleConstants.QuestionAdd} />
      <Card>
        <Card.Body>
          {isLoading ? (
            <Loading />
          ) : (
            <QuestionForm
              onSubmit={onSubmit}
              model={model}
              isSubmitting={isSubmitting}
            />
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default QuestionAdd;
